import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { VenmoImportResult } from "@money/shared";
import { getApiBase } from "./base";
import { accountsKey } from "./accounts";

// Posts the raw CSV text (not JSON) to the import endpoint.
async function postCsv(csv: string): Promise<VenmoImportResult> {
  const res = await fetch(new URL("/transactions/import-venmo", getApiBase()).toString(), {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "text/csv", Accept: "application/json" },
    body: csv,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    throw new Error((data && data.error) || `import failed (${res.status})`);
  }
  return data as VenmoImportResult;
}

export function useImportVenmo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: postCsv,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["transactions"] });
      qc.invalidateQueries({ queryKey: accountsKey });
    },
  });
}
